import { render, staticRenderFns } from "./surveyNew.vue?vue&type=template&id=36782d4c&"
import script from "./surveyNew.vue?vue&type=script&lang=js&"
export * from "./surveyNew.vue?vue&type=script&lang=js&"
import style0 from "./surveyNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports